import {IComponentController} from "angular";
import {UserDto} from "../../model/User";
import {ToastNotificationServiceName, UserServiceName} from "../../../utils/names/serviceNames";
import {UserService} from "../../../users_service/service/user.service";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";

export class DeleteUserDialogComponent implements IComponentController {

    public static instance = ($event, user: UserDto): angular.material.IDialogOptions => ({
        template: require('./delete.user.dialog.component.html'),
        controller: [UserServiceName, ToastNotificationServiceName, '$mdDialog', 'user', DeleteUserDialogComponent],
        controllerAs: 'ctrl',
        locals: {
            user: user
        }
    });


    constructor(private userService: UserService,
                private toastNotificationSerivce: ToastNotificationService,
                private $mdDialog: angular.material.IDialogService,
                private user: UserDto) {

    }

    private deleteUser = () => {
        this.userService.deleteUser(this.user);
        this.$mdDialog.cancel();
    };

    private cancelDelete = () => {
        this.$mdDialog.cancel();
    };

    private deleteUserPermenantly = () => {
        this.userService.deleteUserPermenantly(this.user)
            .then((resp) => {
                if (resp.status == 200) {
                    this.toastNotificationSerivce.generateSuccessMessage('Successfully deleted the user');
                } else {
                    this.toastNotificationSerivce.generateSuccessMessage('Failed to delete the user');
                }
            });
        this.$mdDialog.cancel();
    }
}